import { ModuleWithProviders } from '@angular/core';
import { ConfigService } from '@core/shared/config';
import { DEFAULT_LANGUAGE, FakeMissingTranslationHandler, MissingTranslationHandler, TranslateCompiler, TranslateFakeCompiler, TranslateFakeLoader, TranslateLoader, TranslateModule, TranslateParser, TranslateService, TranslateStore, USE_DEFAULT_LANG, USE_EXTEND, USE_STORE } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { I18nService } from './i18n.service';
import { NestI18NTranslateParser } from './nest-i18n.parser';
import { NgxTranslateAdapterLoader } from './ngx-translate-adapter.loader';
import { I18nState } from './i18n.state';
import { takeWhileAlive } from '../utils';
import { filter } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "./i18n.service";
import * as i2 from "@ngxs/store";
import * as i3 from "@core/shared/config";
export let I18nModule = /*#__PURE__*/(() => {
  class I18nModule extends TranslateModule {
    /**
    * Use this method in your root module to provide the TranslateService
    */
    static forRoot(config = {}) {
      return {
        ngModule: I18nModule,
        providers: [{
          provide: TranslateLoader,
          useFactory: store => {
            return new NgxTranslateAdapterLoader(store);
          },
          deps: [Store]
        }, config.compiler || {
          provide: TranslateCompiler,
          useClass: TranslateFakeCompiler
        }, config.parser || {
          provide: TranslateParser,
          useClass: NestI18NTranslateParser
        }, config.missingTranslationHandler || {
          provide: MissingTranslationHandler,
          useClass: FakeMissingTranslationHandler
        }, TranslateStore, {
          provide: USE_STORE,
          useValue: config.isolate
        }, {
          provide: USE_EXTEND,
          useValue: config.extend
        },
        // These have to be provided but will immediately be overridden in module constructor which can access ConfigService.
        {
          provide: USE_DEFAULT_LANG,
          useValue: config.useDefaultLang
        }, {
          provide: DEFAULT_LANGUAGE,
          useValue: config.defaultLanguage
        }, I18nService, {
          provide: TranslateService,
          useExisting: I18nService
        }]
      };
    }
    /**
     * Use this method in your other (non root) modules to import the directive/pipe
    */
    static forChild(config = {}) {
      return {
        ngModule: I18nModule,
        providers: [config.loader || {
          provide: TranslateLoader,
          useClass: TranslateFakeLoader
        }, config.compiler || {
          provide: TranslateCompiler,
          useClass: TranslateFakeCompiler
        }, config.parser || {
          provide: TranslateParser,
          useClass: NestI18NTranslateParser
        }, config.missingTranslationHandler || {
          provide: MissingTranslationHandler,
          useClass: FakeMissingTranslationHandler
        }, {
          provide: USE_STORE,
          useValue: config.isolate
        }, {
          provide: USE_EXTEND,
          useValue: config.extend
        },
        // These have to be provided but will immediately be overridden in module constructor which can access ConfigService.
        {
          provide: USE_DEFAULT_LANG,
          useValue: config.useDefaultLang
        }, {
          provide: DEFAULT_LANGUAGE,
          useValue: config.defaultLanguage
        }, I18nService, {
          provide: TranslateService,
          useExisting: I18nService
        }]
      };
    }
    constructor(i18n, store, config) {
      super();
      const forcedLang = config.get('i18n.forcedLanguage', null);
      const defaultLang = config.get('i18n.defaultLanguage', 'de');
      i18n.setDefaultLang(forcedLang || defaultLang);
      i18n.use(forcedLang || defaultLang);
      store.select(I18nState.selectedLanguageData).pipe(takeWhileAlive(), filter(data => !!data)).subscribe(data => {
        i18n.reloadLang(i18n.currentLang);
      });
    }
    static {
      this.ɵfac = function I18nModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || I18nModule)(i0.ɵɵinject(i1.I18nService), i0.ɵɵinject(i2.Store), i0.ɵɵinject(i3.ConfigService));
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: I18nModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({});
    }
  }
  return I18nModule;
})();